module.exports = __webpack_public_path__ + "static/media/active-days-video.f3a9b5d3.mp4";